import { User, UserPermissions } from 'entities/user';
import { Action, Types } from '.';

export const Actions = {
  amplifySignedIn: (): Action => ({ type: Types.AMPLIFY_SIGNED_IN }),
  disableMFA: (): Action => ({ type: Types.DISABLE_MFA }),
  populateUser: (user: User): Action => ({
    type: Types.POPULATE_USER,
    payload: { user },
  }),
  refreshPreferredMFA: (): Action => ({ type: Types.REFRESH_PREFERRED_MFA }),
  updatePreferredMFA: (preferredMFA: string): Action => ({
    type: Types.UPDATE_PREFERRED_MFA,
    payload: { preferredMFA },
  }),
  populatePermissions: (permissions: UserPermissions): Action => ({
    type: Types.POPULATE_PERMISSIONS,
    payload: { permissions },
  }),
  signOut: (): Action => ({ type: Types.SIGN_OUT }),
};
